export default {
  searchBar: {
    placeholder: 'เลือกสาขา',
  },
  accountPopover: {
    home: 'หน้าแรก',
    setting: 'ตั้งค่า',
  },
  notificationPopover: {
    title: 'การแจ้งเตือน',
    description: 'คุณมี %{smart_count} ข้อความที่ยังไม่ได้อ่าน',
    viewAll: 'แสดงทั้งหมด',
  },
  calendar: {
    allDay: 'ทั้งวัน',
    previous: 'ก่อนหน้า',
    next: 'ถัดไป',
    today: 'วันนี้',
    month: 'เดือน',
    week: 'สัปดาห์',
    day: 'วัน',
    agenda: 'กำหนดการ',
    date: 'วันที่',
    time: 'เวลา',
    event: 'เหตุการณ์',
  },
}
